import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { connect, useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Paginator from "react-hooks-paginator";
import { LayoutFive } from "../../layouts";
import { getSortedProducts } from "../../lib/product";
import {
  SellerQuickInfo,
  SellerShopProducts,
  VendorProductWrapper,
  TopBar,
  Preloader,
} from "../../components";
import { getShop, getShopProducts } from "../../redux/actions";
import Skeleton from "react-loading-skeleton";
import Swiper from "react-id-swiper";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from "next-i18next";

const ShopProductsList = ({ products }) => {
  const [productList, setProductList] = useState("all");
  const dispatch = useDispatch();
  const [productType, setProductType] = useState("product");
  const { loading_shop, loadingShopProducts, shop_data, shop_products, error_shop } = useSelector(
    (state) => state.shop
  );
  const router = useRouter();
  const { t } = useTranslation('common');
  const { isReady } = router;
  const { heading, subheading, vendor, categories } = shop_data;

  const [layout, setLayout] = useState("grid");
  const [sortType, setSortType] = useState("");
  const [sortValue, setSortValue] = useState("");
  const [filterSortType, setFilterSortType] = useState("");
  const [filterSortValue, setFilterSortValue] = useState("");
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);
  const [shopTopFilterStatus, setShopTopFilterStatus] = useState(false);

  const params = {
    loop: false,
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 10,
    pagination: {
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 5,
        slidesPerGroup: 5,
      },
      769: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      576: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      320: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
  };

  const pageLimit = 30;

  const getLayout = (layout) => {
    setLayout(layout);
  };

  useEffect(() => {
    let sortedProducts = getSortedProducts(shop_products, sortType, sortValue);
    const filterSortedProducts = getSortedProducts(sortedProducts, filterSortType, filterSortValue);
    sortedProducts = filterSortedProducts;
    setSortedProducts(sortedProducts);
    setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
  }, [offset, products, sortType, sortValue, filterSortType, filterSortValue]);

  useEffect(() => {
    if (isReady) {
      const redirect = (to) => router.push(to);
      const vendorId = router.query.seller;
      if (!vendorId) {
        router.push("/");
      }
      dispatch(getShop(vendorId, redirect));
      dispatch(getShopProducts(vendorId, "all"));
    }
  }, [isReady]);

  return (
    <LayoutFive showCategories={false}>
      <div className="shop-content space-pt--50 space-pb--r100">
        <Container>
          <Row className="mb-5">
            <Col>
              {loading_shop == true ? (
                <Skeleton height={100} />
              ) : (
                <SellerQuickInfo
                  seller={shop_products.length > 0 ? shop_products[0].vendor ?? vendor : vendor}
                  shopInfo={heading}></SellerQuickInfo>
              )}
            </Col>
          </Row>
          <Row className="mb-5">
            <Col>
              {categories &&
                (loading_shop == true ? (
                  <Skeleton />
                ) : (
                  <TopBar
                    categories={categories.filter((cat) => cat.status == 1)}
                    setProductList={setProductList}
                    vendorId={router.query.seller}
                    productList={productList}
                  />
                ))}
            </Col>
          </Row>

          <Row>
            <Col>
              {loadingShopProducts == true ? (
                <Preloader location={"home"} />
              ) : (
                <SellerShopProducts
                  layout={layout}
                  products={shop_products}
                  location={"home"}
                  currentPage={1}
                  vendorId={vendor ? vendor.id : router.query.seller}
                />
              )}
            </Col>
            {/* <Col lg={3} className="order-lg-first mt-4 pt-2 mt-lg-0 pt-lg-0">
            
              {subheading &&
                (loading_shop == true ? (
                  <Skeleton count={5} />
                ) : (
                  <Sidebar
                    categories={subheading.category}
                    setProductList={setProductList}
                    vendorId={router.query.seller}
                  />
                ))}
            </Col> */}
          </Row>
          {/* {categories &&
            categories.map((cat) => {
              return (
                <>
                  <Row className="mt-5">
                    <Col lg={12}>
                      <div className="section-title section-title--style-two heading-s1 d-flex justify-content-between align-items-center space-mb--30">
                        <h4>{cat.name}</h4>
                      </div>
                      <div className="product-slider-wrap product-slider-wrap--custom-bullet">
                        <Swiper {...params}>
                          <VendorProductWrapper
                            type={vendor}
                            products={cat.product}
                            sliderClass="swiper-slide"
                            bottomSpace="space-mb--30"
                          />
                        </Swiper>
                      </div>
                    </Col>
                  </Row>
                </>
              );
            })} */}
        </Container>
      </div>
    </LayoutFive>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default ShopProductsList;
